(() => {
  const selector = '.product-single__meta .variant__label-row .scalechart-trigger-btn';

  const updateButton = (button) => {
    button.style.setProperty('position', 'static', 'important');
    button.style.setProperty('top', 'auto', 'important');
    button.style.setProperty('right', 'auto', 'important');
    button.style.setProperty('bottom', 'auto', 'important');
    button.style.setProperty('left', 'auto', 'important');
    button.style.setProperty('z-index', 'auto', 'important');
    button.style.setProperty('margin', '0 0 0 auto', 'important');
  };

  const updateButtons = () => {
    document.querySelectorAll(selector).forEach(updateButton);
  };

  updateButtons();
  const observerRoot = document.querySelector('.product-single__meta') || document.documentElement;
  new MutationObserver(updateButtons).observe(observerRoot, {
    attributes: true,
    attributeFilter: ['style'],
    childList: true,
    subtree: true
  });
})();
